import { render, staticRenderFns } from "./MobileTransactions.vue?vue&type=template&id=6afbb00c&"
import script from "./MobileTransactions.vue?vue&type=script&lang=js&"
export * from "./MobileTransactions.vue?vue&type=script&lang=js&"
import style0 from "./MobileTransactions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports